<template>
  <ContentView>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <b-modal
        v-model="isModalActive"
        has-modal-card
        trap-focus
        aria-role="dialog"
        aria-label="CreateProjectModal"
        :aria-modal="true"
        scroll="keep"
        class="CreateProjectView"
        @close="cancelProjectCreation"
      >
        <div class="modal-card">
          <header class="modal-card-head">
            <H3TitleView class="modal-card-title"
              >{{ $t("myProjects.create-project.title").toString() }}
            </H3TitleView>
            <button
              type="button"
              class="delete"
              aria-label="close"
              @click="cancelProjectCreation"
            ></button>
          </header>
          <section class="modal-card-body">
            <SingleEtablissement :etablissement="chosenEtablissement" />
            <div class="CreateProjectView-infos">
              <b-icon icon="check-circle" type="is-success" />
              <span> {{ $t("myProjects.create-project.etablissementWithoutProject") }} </span>
            </div>
            <InputWithValidation
              v-model="projectName"
              rules="required"
              :label="$t('myProjects.create-project.name')"
              class="CreateProjectView-name"
            />
          </section>
          <footer class="modal-card-foot">
            <div :class="`buttons ${hasPreviousStep ? 'hasPreviousStep' : ''}`">
              <b-button v-if="hasPreviousStep" rounded type="is-primary" @click="goPrevious">
                {{ $t("myProjects.previousStep") }}
              </b-button>
              <div class="modal-finish-buttons">
                <div class="hoverable-discrete-link" @click="cancelProjectCreation">
                  {{ $t("annuler") }}
                </div>
                <b-button rounded type="is-primary" @click="handleSubmit(endProjectCreation)">
                  {{ $t("myProjects.create-project.create") }}
                </b-button>
              </div>
            </div>
          </footer>
        </div>
      </b-modal>
    </ValidationObserver>
  </ContentView>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import ContentView from "@/views/commons/ContentView.vue"
import H3TitleView from "@/views/commons/H3TitleView.vue"
import { EtablissementDTO, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { PROFIL_UTILISATEUR } from "@/model/bean/EnumHelper"
import InputWithValidation from "../inputs/InputWithValidation.vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import SingleEtablissement from "../organisme/SingleEtablissement.vue"
import { BButton, BIcon, BModal } from "buefy"

export default defineComponent({
  name: "CreateProjectView",
  components: {
    ContentView,
    H3TitleView,
    InputWithValidation,
    ValidationObserver,
    SingleEtablissement,
    BButton,
    BIcon,
    BModal,
  },
  props: {
    loggedUser: {
      type: Object as PropType<UtilisateurDTO>,
      required: true,
    },
    chosenEtablissement: {
      type: Object as PropType<EtablissementDTO>,
      required: true,
    },
  },

  emits: ["cancel-project-creation", "end-project-creation"],
  data() {
    return {
      hasPreviousStep: false,
      projectName: "",
      isModalActive: true,
    }
  },
  mounted() {
    this.isModalActive = true
  },
  created(): void {
    if (!this.chosenEtablissement || !this.chosenEtablissement.codeEtablissement) {
      this.$router.push("/myProjects")
    }
    this.hasPreviousStep = this.loggedUser.profil === PROFIL_UTILISATEUR.REFERENT
  },
  methods: {
    goPrevious(): void {
      this.$router.push("/myProjects/new")
    },

    cancelProjectCreation(): void {
      this.$emit("cancel-project-creation")
    },

    endProjectCreation(): void {
      this.$emit("end-project-creation", this.projectName)
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.CreateProjectView {
  .modal-card {
    height: $create-project-modals-height;
    overflow-y: auto !important;
  }

  .animation-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}

.CreateProjectView-infos {
  font-weight: 700;
  margin: 0.25rem 0;
  display: flex;
  align-items: center;
}

.CreateProjectView-name {
  .InputWithValidation-field {
    margin-top: 5rem;
  }
}
</style>
